// removed by extract-text-webpack-plugin
module.exports = {"Stats":"Stats__Stats__g3tw6"};